<template>
    <div id="app">
        <!--<Slogen>
            Kunst hilft heilen - Atmosphäre beflügelt Genesung
        </Slogen>-->
        <router-view/>
    </div>
</template>

<script>
    import Slogen from './components/Slogen'

    export default {
        name: 'app',
        components: {
            Slogen
        }
    }
</script>

<style lang="scss">
    body {
        margin: 0;
        padding: 0;

        background-image: url('./assets/UKSH_Eingangshalle_maske_ohne_motto.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        background-attachment: fixed;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
